import { VerticalPaginationWrapper } from '@/components/PostWrapper';
import { TagWrapper } from '@/components/Shared';
import { LIMIT_POSTS } from '@/constants/post';
import {
  Order_By,
  useGetAllTagsQuery,
  useGetPostsByCategoryIdQuery,
} from '@/generated/graphql';
import format from '@/utils/format';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

const SmallCategoryLeftSection = ({ id }: { id: number }) => {
  const router = useRouter();
  const { query } = router;
  const page = parseInt((query?.page ?? 1) as string);
  const { data: TagData } = useGetAllTagsQuery();

  const { data } = useGetPostsByCategoryIdQuery({
    variables: {
      limit: LIMIT_POSTS,
      offset: (page - 1) * LIMIT_POSTS,
      orderBy: [
        {
          published_at: Order_By.Desc,
        },
      ],
      where: {
        published_at: {
          _is_null: false,
          _lte: 'now()',
        },
      },
      args: {
        category_id: id,
      },
    },
  });

  // const { data } = useGetPostsQuery({
  //   variables: {
  //     limit: LIMIT_POSTS,
  //     offset: (page - 1) * LIMIT_POSTS,
  //     where: {
  //       posts_categories: {
  //         category: {
  //           path_full_slug: {
  //             full_slug: {
  //               _eq: fullSlug,
  //             },
  //           },
  //         },
  //       },
  //     },
  //     orderBy: [
  //       {
  //         created_at: Order_By.Desc,
  //       },
  //     ],
  //   },
  // });

  const dataPosts = format.formatDataPost(data?.get_posts_by_category_id);

  const totalCount = useMemo(
    () => data?.postAggregate?.aggregate?.count,
    [data?.postAggregate],
  );

  return (
    <div className="lg:mr-3 lg:pr-8 flex flex-col lg:border-r-[1px] border-[#b8b8b8]">
      <VerticalPaginationWrapper data={dataPosts} totalCount={totalCount} />

      <div className="pt-10">
        <TagWrapper data={TagData} notFullTag />
      </div>
    </div>
  );
};

export default SmallCategoryLeftSection;
